import {
	Button,
	Card,
	CardBody,
	CardFooter,
	Typography,
} from '@material-tailwind/react';
import { useNavigate } from 'react-router-dom';
import { Order } from '../../types';
import OrderStatusChip from '../components/OrderStatusChip';
import { useOrders } from '../store/orders';

const AnonymousPage = () => {
	const { orders } = useOrders();

	return (
		<div className="flex flex-col gap-4 p-4 bg-blue-gray-50/50 h-full overflow-auto">
			{Object.values(orders)
				.sort(
					(a, b) =>
						new Date(a.time.placed).getTime() -
						new Date(b.time.placed).getTime()
				)
				.map(order => (
					<OrderCard key={order.orderKey} order={order} />
				))}
		</div>
	);
};

const OrderCard = ({ order }: { order: Order }) => {
	const navigate = useNavigate();

	return (
		<Card>
			<CardBody>
				<Typography variant="h5">Order for {order.consumer.name}</Typography>
				<Typography className="break-all">
					<b>External ID: </b>
					{order.externalId}
				</Typography>
				<Typography variant="small">
					Placed: {new Date(order.time.placed).toLocaleString()}
				</Typography>
				<Typography variant="small">Source: {order.source.label}</Typography>
				<OrderStatusChip
					className="inline-block"
					orderStatus={order.status.order}
				/>
			</CardBody>
			<CardFooter className="pt-0">
				<Button
					onClick={() => navigate(`/active-orders/${order.orderKey}/support`)}
					fullWidth
				>
					Chat with Support
				</Button>
			</CardFooter>
		</Card>
	);
};

export default AnonymousPage;
